import React, { Suspense, lazy } from 'react'

const isBrowser = typeof window !== 'undefined'

const TestimonialCarousel = isBrowser
  ? lazy(() => import('./carousel/TestimonialCarousel'))
  : null
const ClientReviewCarousel = isBrowser
  ? lazy(() => import('./carousel/ClientReviewCarousel'))
  : null

export const LazyTestimonialCarousel = (props) => {
  if (!isBrowser) return <div style={{ minHeight: '300px' }} />
  return (
    <Suspense fallback={<div style={{ minHeight: '300px' }} />}>
      <TestimonialCarousel {...props} />
    </Suspense>
  )
}

export const LazyClientReviewCarousel = (props) => {
  if (!isBrowser) return <div style={{ minHeight: '200px' }} />
  return (
    <Suspense fallback={<div style={{ minHeight: '200px' }} />}>
      <ClientReviewCarousel {...props} />
    </Suspense>
  )
}
